import React from 'react';
import { Award, Flame, Star, Trophy, Target, Zap } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

export const BADGE_DEFINITIONS = [
  { id: 'streak_3', name: '3 Dias', description: 'Complete qualquer hábito por 3 dias seguidos', icon: 'Flame', color: 'from-orange-400 to-red-500', points: 10 },
  { id: 'streak_7', name: 'Uma Semana', description: '7 dias de streak', icon: 'Star', color: 'from-yellow-400 to-orange-500', points: 25 },
  { id: 'streak_14', name: 'Duas Semanas', description: '14 dias de streak', icon: 'Trophy', color: 'from-blue-400 to-purple-500', points: 50 },
  { id: 'streak_30', name: 'Um Mês', description: '30 dias de streak', icon: 'Award', color: 'from-purple-400 to-pink-500', points: 100 },
  { id: 'perfect_day', name: 'Dia Perfeito', description: 'Complete todos os hábitos em um dia', icon: 'Target', color: 'from-emerald-400 to-teal-500', points: 20 },
  { id: 'century', name: 'Centenário', description: 'Acumule 100 pontos', icon: 'Zap', color: 'from-indigo-400 to-blue-500', points: 0 },
];

const ICON_MAP = {
  Flame, Star, Trophy, Award, Target, Zap
};

const BadgesList = ({ earnedBadges }) => {
  return (
    <Card className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground mb-1">Conquistas</h2>
        <p className="text-sm text-muted-foreground">
          Complete desafios para desbloquear badges
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {BADGE_DEFINITIONS.map((badge) => {
          const Icon = ICON_MAP[badge.icon];
          const isEarned = earnedBadges.includes(badge.id);

          return (
            <div
              key={badge.id}
              className={`relative p-4 rounded-xl border-2 transition-all duration-300 ${isEarned
                  ? 'border-emerald-500 dark:border-emerald-600 bg-gradient-to-br shadow-md ' + badge.color.replace('from-', 'from-').replace('to-', 'to-') + ' hover:scale-105'
                  : 'border-border bg-muted/50 opacity-60 hover:opacity-80'
                }`}
            >
              <div className="flex flex-col items-center text-center space-y-2.5">
                <div
                  className={`w-14 h-14 rounded-xl flex items-center justify-center transition-all ${isEarned ? 'bg-white/20 backdrop-blur-sm shadow-lg' : 'bg-muted-foreground/10'
                    }`}
                >
                  <Icon className={`w-7 h-7 ${isEarned ? 'text-white' : 'text-muted-foreground'}`} />
                </div>
                <div className="space-y-1">
                  <h3 className={`font-semibold text-sm leading-tight ${isEarned ? 'text-white' : 'text-foreground'}`}>
                    {badge.name}
                  </h3>
                  <p className={`text-xs leading-tight ${isEarned ? 'text-white/90' : 'text-muted-foreground'}`}>
                    {badge.description}
                  </p>
                  {badge.points > 0 && (
                    <div className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium mt-1.5 ${isEarned
                        ? 'bg-white/25 text-white'
                        : 'bg-muted text-muted-foreground'
                      }`}>
                      +{badge.points} XP
                    </div>
                  )}
                </div>
              </div>
              {isEarned && (
                <div className="absolute -top-1.5 -right-1.5 w-7 h-7 rounded-full bg-white dark:bg-slate-900 flex items-center justify-center border-2 border-emerald-500 dark:border-emerald-600 shadow-md">
                  <svg className="w-4 h-4 text-emerald-500 dark:text-emerald-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default BadgesList;
